<template>
  <div>
    <!-- 商品发布的编辑 -->
    <release-sku-edit v-if="ifEdit" :product-audit-id="productAuditId" :if-edit="ifEdit"></release-sku-edit>
    <!-- 商品维护的编辑 -->
    <sku-edit v-else :sku-id="skuId" :product-audit-id="productAuditId" />
  </div>
</template>

<script>
import SkuEdit from './components/skuEdit.vue';
import ReleaseSkuEdit from './components/releaseSkuEdit.vue';

export default {
  components: { SkuEdit, ReleaseSkuEdit },
  data() {
    return {
      productAuditId: 0,
      skuId: 0,
      ifEdit: false,
    };
  },
  created() {
    const { productAuditId = '', skuId = '' } = this.$route.query;
    if (productAuditId && productAuditId.includes('x')) {
      this.productAuditId = +productAuditId.slice(0, -1);
      this.ifEdit = true;
    } else {
      this.productAuditId = +productAuditId;
    }
    this.skuId = +skuId;
  },
  methods: {},
};
</script>
<style lang="scss" scoped></style>
